import React from 'react'
import { Icon } from '../../components/Icon'


const TermsAndConditions: React.FC = () => {
  return (
    <div className="bg-white h-[600px] overflow-scroll py-10 px-6 shadow  rounded-[1rem]">
    
      <div className="flex flex-col py-2 gap-3 justify-center align-middle items-center text-center">
        <Icon
          name={'IconFileCheckInActive'}
          width={52}
          height={52}
          strokeWidth={0.5}
          stroke="#02698C"
        />
        <p className="text-lg font-bold leading-6 text-text2">
          Terms and Conditions
        </p>
      </div>
      <div className="mt-2">
        <p className="text-[9px] font-bold leading-4 text-text1">
          #Introduction
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          These terms of use govern your use of 360safeguarding.io. By using our
          website, you accept these terms of use in full. If you disagree with
          these terms of use or any part of these terms of use, you must not use
          our website.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          Licence to use website
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          You may not, without prior permission:
        </p>

        <ul className="list-disc pl-3">
          <li className="text-[9px] font-normal leading-4 text-text1">
            epublish material from this website (including republication on
            another website); sell, rent or sub-license material from the
            website;
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Show any material from the website in public;
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Reproduce, duplicate, copy or otherwise exploit material on our
            website for a commercial purpose;
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Edit or otherwise modify any material on the website; or
            redistribute material from this website [except for content
            specifically and expressly made available for redistribution (such
            as our newsletter)].
          </li>
          <li className="text-[9px] font-normal leading-4 text-text1">
            Unless otherwise stated, we or our licensors own the intellectual
            property rights in the website and material on the website. Subject
            to the licence below, all these intellectual property rights are
            reserved. You may view, download for caching purposes only, and
            print pages from the website for your own personal use, subject to
            the restrictions set out below and elsewhere in these terms of use.
            You must not: Where content is specifically made available for
            redistribution, it may only be redistributed within your
            organisation.
          </li>
        </ul>

        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Acceptable Use
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          You must not use our website in any way that causes, or may cause,
          damage to the website or impairment of the availability or
          accessibility of the website; or in any way which is unlawful,
          illegal, fraudulent or harmful, or in connection with any unlawful,
          illegal, fraudulent or harmful purpose or activity.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          You must not use our website to copy, store, host, transmit, send,
          use, publish or distribute any material which consists of (or is
          linked to) any spyware, computer virus, Trojan horse, worm, keystroke
          logger, rootkit or other malicious computer software. You must not
          conduct any systematic or automated data collection activities
          (including without limitation scraping, data mining, data extraction
          and data harvesting) on or in relation to our website without our
          express written consent.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          You must not use our website to transmit or send unsolicited
          commercial communications. You must not use our website for any
          purposes related to marketing without our express written consent.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Restricted Access
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          Access to certain areas of our website is restricted. We reserve the
          right to restrict access to other areas of our website, or indeed our
          whole website, at our discretion. If we provide you with a user ID and
          password to enable you to access restricted areas of our website or
          other content or services, you must ensure that that user ID and
          password is kept confidential. We may disable your user ID and
          password in our sole discretion without notice or explanation.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          User Generated Content
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          In these terms of use, “your user content” means material (including
          without limitation text, images, audio material, video material and
          audio-visual material) that you submit to our website, for whatever
          purpose. You grant to us a worldwide, irrevocable, non-exclusive,
          royalty-free licence to use, reproduce, adapt, publish, translate and
          distribute your user content in any existing or future media. You also
          grant to us the right to sub-license these rights, and the right to
          bring an action for infringement of these rights. Your user content
          must not be illegal or unlawful, must not infringe any third party’s
          legal rights, and must not be capable of giving rise to legal action
          whether against you or us or a third party (in each case under any
          applicable law). You must not submit any user content to the website
          that is or has ever been the subject of any threatened or actual legal
          proceedings or other similar complaints. We reserve the right to edit
          or remove any material submitted to our website, or stored on our
          servers, or hosted or published upon our website. Notwithstanding our
          rights under these terms of use in relation to user content, we do not
          undertake to monitor the submission of such content to, or the
          publication of such content on, our website.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Limited Warranties
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          Whilst we endeavour to ensure that the information on this website is
          correct, we do not warrant its completeness or accuracy; nor do we
          commit to ensuring that the website remains available or that the
          material on the website is kept up-to-date. To the maximum extent
          permitted by applicable law we exclude all representations, warranties
          and conditions relating to this website and the use of this website
          (including, without limitation, any warranties implied by law of
          satisfactory quality, fitness for purpose and/or the use of reasonable
          care and skill).
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Limitations of Liability
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          To the extent that the website and the information and services on the
          website are provided free of charge, we will not be liable for any
          loss or damage of any nature;
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          We will not be liable for any consequential, indirect or special loss
          or damage;
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          We will not be liable for any loss of profit, income, revenue,
          anticipated savings, contracts, business, goodwill, reputation, data,
          or information;
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          We will not be liable for any loss or damage arising out of any event
          or events beyond our reasonable control;
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          Our maximum liability in relation to any event or series of related
          events will be limited to a reasonable amount.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          Nothing in these terms of use (or elsewhere on our website) will
          exclude or limit our liability for fraud, for death or personal injury
          caused by our negligence, or for any other liability which cannot be
          excluded or limited under applicable law. Subject to this, our
          liability to you in relation to the use of our website or under or in
          connection with these terms of use, whether in contract, tort
          (including negligence) or otherwise, will be limited as follows:
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Indemnity
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          You hereby indemnify us and undertake to keep us indemnified against
          any losses, damages, costs, liabilities and expenses (including
          without limitation legal expenses and any amounts paid by us to a
          third party in settlement of a claim or dispute on the advice of our
          legal advisers) incurred or suffered by us arising out of any breach
          by you of any provision of these terms of use, or arising out of any
          claim that you have breached any provision of these terms of use.
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          Breaches of these terms of use Without prejudice to our other rights
          under these terms of use, if you breach these terms of use in any way,
          we may take such action as we deem appropriate to deal with the
          breach, including suspending your access to the website, prohibiting
          you from accessing the website, blocking computers using your IP
          address from accessing the website, contacting your internet service
          provider to request that they block your access to the website and/or
          bringing court proceedings against you.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Variation
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          We may revise these terms of use from time to time. Revised terms of
          use will apply to the use of our website from the date of the
          publication of the revised terms of use on our website. Please check
          this page regularly to ensure you are familiar with the current
          version.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Assignment
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          We may transfer, sub-contract or otherwise deal with our rights and/or
          obligations under these terms of use without notifying you or
          obtaining your consent. You may not transfer, sub-contract or
          otherwise deal with your rights and/or obligations under these terms
          of use.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Severability
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          If a provision of these terms of use is determined by any court or
          other competent authority to be unlawful and/or unenforceable, the
          other provisions will continue in effect. If any unlawful and/or
          unenforceable provision would be lawful or enforceable if part of it
          were deleted, that part will be deemed to be deleted, and the rest of
          the provision will continue in effect.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Exclusion of Third-Party Rights
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          These terms of use are for the benefit of you and us and are not
          intended to benefit any third party or be enforceable by any third
          party. The exercise of our and your rights in relation to these terms
          of use is not subject to the consent of any third party.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Entire Agreement
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-[2px]">
          These terms of use together with our privacy policy constitute the
          entire agreement between you and us in relation to your use of our
          website and supersede all previous agreements in respect of your use
          of this website.
        </p>
        <p className="text-[9px] font-bold leading-4 text-text1 mt-6">
          Law and Jurisdiction
        </p>
        <p className="text-[9px] font-normal leading-4 text-text1 mt-4">
          These terms of use will be governed by and construed in accordance
          with English law, and any disputes relating to these terms of use will
          be subject to the non-exclusive jurisdiction of the courts of England
          and Wales.
        </p>
      </div>
    </div>
  )
}

export default TermsAndConditions
